// extracted by mini-css-extract-plugin
export var lg = "_4m-4";
export var md = "_4m-3";
export var sm = "_4m-2";
export var xs = "_4m-1";
export var xxs = "_4m-0";